export default __webpack_public_path__ + "static/media/mx_ad_banner.874a6d58.jpg";